// project imports
import BlogPage from 'views/pages/blog';
import AEOArticle from 'sections/blog/articles/AEOArticle';
import CommonLayout from 'layout/CommonLayout';

// ==============================|| BLOG ROUTING ||============================== //

const BlogRoutes = {
  path: 'blog',
  element: <CommonLayout />,
  children: [
    {
      path: '',
      element: <BlogPage />
    },
    {
      path: 'answer-engine-optimization-aeo',
      element: <AEOArticle />
    }
    // Add more blog-related routes here in the future
    // For example:
    // {
    //   path: 'blog/:articleId',
    //   element: <ArticleDetail />
    // }
  ]
};

export default BlogRoutes; 